import { onViewerBootstrapLoaded } from "./StaticAssets";
import {
  EptBreakdownMetricNames,
  openEptMetricsContext,
} from "./telemetry/TelemetryBreakdown";

type ViewerBootstrapper = {
  bootstrap: (authToken: string | null) => void;
  showLyteboxIfNeeded: () => void;
};
type Bootstrapper = {
  ViewerBootstrap: {
    get_instance: () => ViewerBootstrapper;
  };
};
type BootstrapWindow = Window &
  typeof globalThis & { tabBootstrap: Bootstrapper };

export function bootstrap(authToken: string | null) {
  onViewerBootstrapLoaded(() => {
    const viewerBootstrap = (
      window as BootstrapWindow
    ).tabBootstrap.ViewerBootstrap.get_instance();
    // Existing metric BTSTRP doesn't distinguish error case. EPT breakdown adds that missing data
    openEptMetricsContext([
      EptBreakdownMetricNames.bootstrapOnInitial,
      EptBreakdownMetricNames.bootstrapOnErr,
    ]);
    viewerBootstrap.bootstrap(authToken);
    viewerBootstrap.showLyteboxIfNeeded();
  });
}
